import { Flex, type FlexProps } from "@radix-ui/themes";

type HStackProps = FlexProps & {
  children: React.ReactNode;
};
export default function Hstack({ children, ...props }: HStackProps) {
  return (
    <Flex direction={"row"} gap={"2"} {...props}>
      {children}
    </Flex>
  );
}
